module.exports = __webpack_public_path__ + "media/images/features/support/eyecatch-type-03-731af9ca812b853ea44b21e18f0382a1.svg";